import axios from 'axios';

export const apiTranslations = function (brand, endpoint, language, translationApiEndpoint) {//eslint-disable-line
  let url = `https://translation-api${window.location.host.indexOf('staging') > -1 ? '-staging' : ''}${endpoint || `.${brand}`}.com/api/v1/translations/i18n/${language}`;
  if (translationApiEndpoint) {
    url = `${translationApiEndpoint}/api/v1/translations/i18n/${language}`;
  }
  return axios.get(url);
};

  export const addMissingTranslation = function (brand, endpoint, defaultLanguage, key, defaultValue, translationApiEndpoint) {//eslint-disable-line
  let url = `https://translation-api${window.location.host.indexOf('staging') > -1 ? '-staging' : ''}${endpoint || `.${brand}`}.com/api/v1/key/withdefaulttranslation`;
  if (translationApiEndpoint) {
    url = `${translationApiEndpoint}/api/v1/key/withdefaulttranslation`;
  }
  return axios.post(url, {
    key,
    defaultValue,
    defaultLanguage,
  });
};



// WEBPACK FOOTER //
// ./src/api/translations.js